import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatFileUpload = createCustomElementWrapper('kat-file-upload', 'KatFileUpload', {
    'fileStates': 'file-states',
    'fileView': 'file-view',
    'hideClearAll': 'hide-clear-all',
    'maxFilesPerGridRow': 'max-files-per-grid-row',
    'maxSize': 'max-size',
}, {
    'onFilesAttached': 'filesAttached',
    'onFilesAttachedError': 'filesAttachedError',
    'onFilesRemoved': 'filesRemoved',
    'onFilesReplaced': 'filesReplaced',
}, [
    'label',
    'hint',
    'error',
    'constraints-message',
    'file-thumbnail-FILE_NAME',
    'file-error-summary-FILE_NAME',
    'file-error-detail-FILE_NAME',
]);
